export default "__VITE_ASSET__DmAX2hSA__"